import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const GenerateInquiryLinkMutation = graphql.persisted(
  "GenerateInquiryLink",
  graphql(`mutation GenerateInquiryLink($input: GenerateInquiryLinkInput!) {
    generateInquiryLink(input: $input) {
      schoolYear { id inquiryToken }
      userErrors { message path }
    }
  }`)
);

export { GenerateInquiryLinkMutation };
export function useGenerateInquiryLink() {
  return useMutation(GenerateInquiryLinkMutation);
}
